export default {
    props: {
        title: {
            type: String, 
            require: true,
        },
        text: {
            type: String, 
            require: true,
        },
        buttonText: {
            type: String, 
            require: true, 
        },
        buttonLink: {
            type: String, 
            require: true,
        },
        withEmoji: {
            type: Boolean,
            default: false,
        }
    }
}
